export default __webpack_public_path__ + "static/media/person (4).3ed1265f.png";